import { LAYOUTS, ModalAlignmentEnum, POSITION, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { heightMap } from '../../configs/height';
import { ACTION } from "./types";
import { onClosePopup, onShareLink, onTrackCustomerJourney } from "./actions";
import { partnerDetailsDSBuilder, returnDateInString } from "./utils";
import { addCommasToNumber, isMobile } from "../../configs/utils";
import { getEpochTime } from "../dashboard/utils";
const _isMobile = isMobile();
export const template = async (FieldsObject, user, customerName, customerPhoneNumber, activeCustomer) => ({
    layout: {
        id: ROUTE.PLATFORM_VIEW_DETAILS,
        type: LAYOUTS.MODAL,
        style: _isMobile ? {
            isPartnerPlatform: true,
            height: heightMap[ROUTE.PLATFORM_VIEW_DETAILS],
        } : {
            //@ts-ignore
            isPartnerPlatform: true,
            alignment: ModalAlignmentEnum.RIGHT,
            height: 360
        },
        widgets: [
            { id: 'partnerViewDetailsLeadsHeader', type: WIDGET.STACK, position: POSITION.ABSOLUTE_TOP },
            { id: 'partnerViewDetailsLeadsBody', type: WIDGET.STACK },
        ],
    },
    datastore: {
        partnerViewDetailsLeadsHeader: {
            width: StackWidth.MATCH_PARENT,
            type: StackType.column,
            padding: {
                top: SizeTypeTokens.XL,
            },
            widgetItems: [
                { id: 'partnerViewDetailsLeadsHeaderTopStack', type: WIDGET.STACK },
                { id: 'partnerViewDetailsLeadsHeaderBottomStack', type: WIDGET.STACK },
                { id: 'partnerViewDetailsLeadsHeaderDivider', type: WIDGET.DIVIDER }
            ]
        },
        partnerViewDetailsLeadsHeaderDivider: {
            size: DividerSizeTokens.MD,
            color: ColorTokens.Grey_Chalk
        },
        partnerViewDetailsLeadsHeaderTopStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.spaceBetween,
            alignItems: StackAlignItems.center,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL
            },
            widgetItems: [
                { id: 'partnerViewDetailsLeadsHeader_TopStackT1', type: WIDGET.TEXT },
                { id: 'partnerViewDetailsLeadsHeader_CloseIcon', type: WIDGET.ICON },
            ]
        },
        partnerViewDetailsLeadsHeader_TopStackT1: {
            label: `${customerName ? customerName : customerPhoneNumber ? customerPhoneNumber : ''}`,
            fontWeight: '600',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            lineHeight: 24,
        },
        partnerViewDetailsLeadsHeader_CloseIcon: {
            name: IconTokens.Cross,
            color: ColorTokens.Grey_Night,
            size: IconSizeTokens.XXXL,
            action: {
                routeId: ROUTE.PLATFORM_VIEW_DETAILS,
                type: ACTION.CLOSE_POPUP,
                payload: {}
            }
        },
        partnerViewDetailsLeadsHeaderBottomStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XL
            },
            widgetItems: [
                customerName ? { id: 'partnerViewDetailsLeadsHeaderBottomStackT1', type: WIDGET.TEXT } : {}
            ]
        },
        partnerViewDetailsLeadsHeaderBottomStackT1: {
            label: `${customerPhoneNumber ? customerPhoneNumber : ''}`,
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Night,
            lineHeight: 24,
        },
        partnerViewDetailsLeadsBody: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL
            },
            widgetItems: partnerDetailsDSBuilder(FieldsObject).WIDGET_STORE
        },
        ...partnerDetailsDSBuilder(FieldsObject).DATA_STORE,
        partnerViewDetailsLeadsFooter_shareLinkBtnStack: {
            type: StackType.row,
            flex: 1,
            widgetItems: [
                { id: 'partnerViewDetailsLeadsFooter_shareLinkBtn', type: WIDGET.BUTTON }
            ]
        },
        partnerViewDetailsLeadsFooter_assistedJourneyBtnStack: {
            type: StackType.row,
            flex: 1,
            widgetItems: [
                { id: 'partnerViewDetailsLeadsFooter_assistedJourneyBtn', type: WIDGET.BUTTON }
            ]
        },
        partnerViewDetailsLeadsFooter_shareLinkBtn: {
            type: ButtonTypeTokens.MediumSoftFilled,
            width: ButtonWidthTypeToken.FULL,
            label: 'Share link',
            action: {
                routeId: ROUTE.PLATFORM_VIEW_DETAILS,
                type: ACTION.SHARE_LINK,
                payload: {
                    value: user
                }
            }
        },
        partnerViewDetailsLeadsFooter_assistedJourneyBtn: {
            type: ButtonTypeTokens.MediumFilled,
            width: ButtonWidthTypeToken.FULL,
            label: activeCustomer ? 'View as client' : 'Register customer',
            fontSize: FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Inter,
            action: {
                routeId: ROUTE.PLATFORM_VIEW_DETAILS,
                type: ACTION.ON_TRACK_CUSTOMER_JOURNEY,
                payload: {
                    value: user
                }
            }
        },
        partnerViewDetailsLeadsFooterSpace0: {
            size: SizeTypeTokens.XL
        }
    },
});
export const platformviewDetailsMF = {
    onLoad: async ({ asyncStorage, setDatastore }, { user, leads, activeCustomer }) => {
        let _FieldsObject = {};
        let customerName;
        let customerPhoneNumber;
        if (leads) {
            customerName = user?.name || user?.customerName;
            customerPhoneNumber = user?.mobileNumber;
            _FieldsObject = {
                "Email Id": `${user?.email === undefined || user?.email === null ? 'Not available' : (user?.email)}`,
                "PAN": `${user?.pan === undefined || user?.pan === null ? 'Not available' : user?.pan}`,
                "Last update": `${returnDateInString(user?.applicationLastUpdateTS)} ${getEpochTime(user?.applicationLastUpdateTS)}`,
                "Created date": `${returnDateInString(user?.applicationCreationTS)} ${getEpochTime(user?.applicationCreationTS)}`,
                "Status": `${user.applicationStatus ? user.applicationStatus : ''}`,
                "Fetched portfolio": `₹${addCommasToNumber(user?.fetchedPortfolioAmount | 0)}`,
                "Available credit limit": `₹${addCommasToNumber(user?.availableLimit | 0)}`,
                "Pledged portfolio": `₹${addCommasToNumber(user?.pledgedPortfolioAmount | 0)}`,
                "Pledged credit limit": `₹${addCommasToNumber(user?.pledgedLimit | 0)}`,
            };
        }
        if (activeCustomer) {
            customerName = user?.name || user?.customerName;
            customerPhoneNumber = user?.mobileNumber;
            _FieldsObject = {
                "Available credit limit": `₹${addCommasToNumber(user?.creditDetails?.availableCreditAmount | 0)}`,
                "Total credit limit": `₹${addCommasToNumber(user?.creditDetails?.totalCreditAmount | 0)}`,
                "Portfolio pledged": `₹${addCommasToNumber(user?.creditDetails?.pledgedPortfolioAmount | 0)}`,
                "Outstanding amount": `₹${addCommasToNumber(user?.creditDetails?.principalOutStandingAmount | 0)}`,
                "Interest rate": `${user?.creditDetails?.currentApplicableInterestRate} %`,
                "Created date": user?.createdOn === null || user?.createdOn === undefined ? '' : `${returnDateInString(user?.createdOn)} ${getEpochTime(user?.createdOn)}`
            };
        }
        // eslint-disable-next-line prefer-const
        // eslint-disable-next-line prefer-const
        return Promise.resolve(template(_FieldsObject, user, customerName, customerPhoneNumber, activeCustomer));
    },
    actions: {
        [ACTION.CLOSE_POPUP]: onClosePopup,
        [ACTION.SHARE_LINK]: onShareLink,
        [ACTION.ON_TRACK_CUSTOMER_JOURNEY]: onTrackCustomerJourney
    },
};
